import { ProductFormProvider } from "../../contexts/ProductFormContext";
import { CreateProductContent } from "./CreateProductContent";

type Props = {
  onBack: () => void;
};

export const CreateProduct = ({ onBack }: Props) => {
  return (
    <ProductFormProvider>
      <CreateProductContent onBack={onBack} />
    </ProductFormProvider>
  );
};
